import React from 'react';
import LocationTemplate from './LocationTemplate';

const ConetoePage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Conetoe"
      stateName="North Carolina"
      countyName="Edgecombe"
      zipCodes={["27819"]}
      latitude={35.8182}
      longitude={-77.4086}
      population={294}
      historicalFact="Name derived from an indigenous word meaning 'pine cone people' or 'pine burr place.'"
      nearbyTowns={[
        "Tarboro, NC",
        "Rocky Mount, NC",
        "Bethel, NC",
        "Robersonville, NC",
        "Williamston, NC",
        "Elm City, NC",
        "Pinetops, NC",
        "Greenville, NC"
      ]}
    />
  );
};

export default ConetoePage;